import { observer } from "mobx-react-lite";
import { BulkActionBar } from "@/domains/documents/components/molecules/BulkActionBar";
import { useLanguage } from "@/lib/i18n/LanguageContext";
import { IssueActionsMenu } from "./IssueActionsMenu";

interface IssueBulkActionsProps {
  /** Currently checked issue ids (in render order). Empty = toolbar hidden. */
  selectedIssueIds: number[];
  buildingId: number;
  onClear: () => void;
}

/**
 * Floating bulk-action toolbar for the /issues list view (WHA-3334).
 * WHA-3428: slimmed to two controls — the built-in "Clear" and an
 * "Actions" dropdown that mirrors the right-click context menu and
 * applies to every selected issue.
 */
export const IssueBulkActions = observer(function IssueBulkActions({
  selectedIssueIds,
  buildingId,
  onClear,
}: IssueBulkActionsProps) {
  const { t } = useLanguage();

  if (selectedIssueIds.length === 0) return null;

  const selectionLabel =
    selectedIssueIds.length === 1
      ? t.pm.issues.bulkActions.issueSelected
      : t.pm.issues.bulkActions.issuesSelected;

  return (
    <BulkActionBar
      selectedCount={selectedIssueIds.length}
      selectionLabel={selectionLabel}
      onClearSelection={onClear}
      customActions={({ compact }) => (
        <IssueActionsMenu
          selectedIssueIds={selectedIssueIds}
          buildingId={buildingId}
          compact={compact}
        />
      )}
    />
  );
});
